import './quote-assessment.css';

/**
 * The customer's own note on their trade-in, shown on Quote Assessment itself
 * and on the warehouse Testing screen.
 *
 * The note used to be visible only inside the "Customer's submission" dialog,
 * so an assessor had to know to open it. It often changes the price ("the
 * left channel crackles", "boxed with the manual"), so it sits on the page.
 *
 * Rendered as text, never as HTML: it is whatever the customer typed. Line
 * breaks are kept (pre-wrap), because notes added from the success screen are
 * appended with a blank line between them and must stay separate.
 *
 * Imports its own stylesheet so it renders the same outside Quote Assessment.
 * `style` lets a host page space it without an empty wrapper when no note exists.
 */
export default function CustomerNotePanel({ notes, style }) {
    if (!notes || !String(notes).trim()) return null;
    return (
        <section className="qa-customer-note card" aria-label="Customer note" style={style}>
            <div className="qa-lab">Customer note</div>
            <div className="qa-note-text">{notes}</div>
        </section>
    );
}
